/** WCAG 2.4.1 — atalho para o primeiro conteúdo útil (teclado / leitores de ecrã). */
export function SkipLink() {
  return (
    <a
      href="#conteudo-principal"
      className="skip-to-main"
    >
      Saltar para o conteúdo principal
    </a>
  );
}
